export const KPI = {
  totalPrice: '売上',
  orderCount: '注文数',
} as const;
export type KPI = keyof typeof KPI;
